import { useState } from "react";
import { Box, IconButton, Drawer, Button, Typography} from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { UpdateIcon,InfoIcon } from "../../../../../../core/global/Icons"
import { FileInfo } from "./FileInfo";

export const ThreeDots = ({handleUpdate, v, handleMOpen, isLoading}) =>{
    const [open, setOpen] = useState(false);
    const [fileOpen, setFileOpen] = useState (false)

    return (
        <Box>
            <IconButton onClick={(e) =>{e.stopPropagation(); setOpen(true)}}>
                <MoreVertIcon />
            </IconButton>
                <Drawer anchor="bottom" open={open} onClose={() => setOpen(false)} PaperProps={{sx: {borderTopLeftRadius: 16,borderTopRightRadius: 16 }}} >
                    <Box bgcolor="#fdfdfdff" p={2} borderRadius="16px 16px 0px 0px" boxShadow="0px 0px 24px rgba(0, 0, 0, 0.08)">
                        <Box display="flex" justifyContent="center" mb={1}>
                            <Box height="2px" width="37px" bgcolor="#333333" />
                        </Box>
                            <Typography  fontSize={14} fontWeight={600} lineHeight="25px" noWrap>
                                {v.name}
                            </Typography>
                        <Box>
                            <Button  fullWidth sx={{fontSize:'14px',  display:'flex', justifyContent:'start', color:'#000000ff'}} onClick={(e)=>{e.stopPropagation();handleMOpen(true);setFileOpen(true);setOpen(false)}}>
                                <InfoIcon stroke='#292d32' width="20" height="20"/>
                                <Typography sx={{ml:'10px', fontSize:'14px'}}>View Details</Typography>
                            </Button>
                            <Button  fullWidth sx={{fontSize:'14px',  display:'flex', justifyContent:'start', color:'#000000ff'}}onClick={(e) => {e.stopPropagation();handleUpdate(e, v);setOpen(false)}}>
                                <UpdateIcon stroke='#292d32' width="20" height="20" />
                                <Typography sx={{ml:'10px', fontSize:'14px'}}>Update</Typography>
                            </Button>
                        </Box>
                    </Box>
                </Drawer>
            <FileInfo open={fileOpen} onClose={()=>setFileOpen(false)} v={v}  isLoading={isLoading} />
        </Box>
    )
}

